import { render, staticRenderFns } from "./contrat-form.vue?vue&type=template&id=0747b4b4&scoped=true"
import script from "./contrat-form.vue?vue&type=script&lang=js"
export * from "./contrat-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747b4b4",
  null
  
)

export default component.exports